/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "token",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receivedTokenAddress",
                type: "address",
            },
        ],
        name: "InvalidTokenContract",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "TokenReceived",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "onTokenReceived",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506040516101d83803806101d883398101604081905261002f91610054565b600080546001600160a01b0319166001600160a01b0392909216919091179055610084565b60006020828403121561006657600080fd5b81516001600160a01b038116811461007d57600080fd5b9392505050565b610145806100936000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c80631035fb5c14610030575b600080fd5b61004361003e3660046100d7565b610045565b005b60005433906001600160a01b031681146100815760405163265b0f7b60e01b81526001600160a01b038216600482015260240160405180910390fd5b604080516001600160a01b038516815260208101849052606081830181905260009082015290517fefe605af9663e0f15f1dd40dad79f119df71e8d2affb3f6857cb9707c6c4b3ea9181900360800190a1505050565b600080604083850312156100ea57600080fd5b82356001600160a01b038116811461010157600080fd5b94602093909301359350505056fea2646970667358221220514d1b54716fe39dd08457e21eb8f4540f3b09ab4fc8c883d0528637c554ce9664736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleERC20Receiver__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(token, overrides) {
        return super.getDeployTransaction(token, overrides || {});
    }
    deploy(token, overrides) {
        return super.deploy(token, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleERC20Receiver__factory.bytecode = _bytecode;
ExampleERC20Receiver__factory.abi = _abi;
//# sourceMappingURL=ExampleERC20Receiver__factory.js.map